import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";

export const useResendUserInviteMutation = () => {
  const { t } = useTranslation(["user_management"]);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { invite_email: string }) => await apiClient.resendUserInvitation(payload),
    onSuccess: (data) => {
      successToast({
        message: data,
      });
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "userInvitations" }],
      });
    },
    onError: () => {
      errorToast({ message: t(($) => $.user_management["Failed to resend user invitation"]) });
    },
  });
};
